import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { bookAppointmentOnSurveyLinkClick } from "../../../../../data-layer/v3/data-layer/actions.js";
import { useAppointmentContext } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
import AppointmentSurvey from "./AppointmentSurvey.js";
import useVirtualAppointment from "../../../../../pages/BookAppointment/hooks/v3/pages/BookAppointment/hooks/use-virtual-appointment.js";
const AppointmentSurveyContainer = (props) => {
  const { getLabel } = useIntl();
  const [, { type, appointment, store, timeSlot }] = useAppointmentContext();
  const { featureConfigs } = useFeatureToggles();
  const [{ isVirtualAppointmentType }] = useVirtualAppointment();
  const labels = React.useMemo(
    () => ({
      title: getLabel("appointments.component.appointmentSurvey.title"),
      description: getLabel("appointments.component.appointmentSurvey.description"),
      cta: getLabel("appointments.component.appointmentSurvey.cta")
    }),
    [getLabel]
  );
  const surveyUrl = React.useMemo(() => {
    if (!type || !appointment?.id || appointment?.isReservation) {
      return;
    }
    if (featureConfigs.appointmentBookingSurveyLinksStoreCodes && !featureConfigs.appointmentBookingSurveyLinksStoreCodes?.find(
      (code) => Number(code) === store?.code
    )) {
      return;
    }
    const appointmentBookingSurveyConfig = featureConfigs.appointmentBookingSurveyLinks?.find(
      (appointmentBookingSurveyLink) => appointmentBookingSurveyLink[0] === type?.id
    );
    if (appointmentBookingSurveyConfig) {
      return appointmentBookingSurveyConfig[1]?.replace(`{appointmentId}`, appointment.id);
    }
  }, [
    appointment,
    type,
    featureConfigs.appointmentBookingSurveyLinks,
    featureConfigs.appointmentBookingSurveyLinksStoreCodes,
    store?.code
  ]);
  const onSurveyLinkClick = React.useCallback(() => {
    if (store && type && timeSlot && appointment) {
      const dataLayerEvent = bookAppointmentOnSurveyLinkClick({
        store: !isVirtualAppointmentType(type) ? {
          code: store.code,
          globalStoreId: store.globalStoreId,
          streetName: store.streetName,
          town: store.town,
          name: store.name,
          postalCode: store.postalCode,
          streetNumber: store.streetNumber,
          additionalStreetInfo: store.additionalStreetInfo
        } : void 0,
        appointment: {
          id: appointment?.id,
          appointmentType: {
            id: type.id,
            ageGroup: type.ageGroup,
            isVirtualAppointment: isVirtualAppointmentType(type)
          },
          startTime: timeSlot?.from,
          endTime: timeSlot?.until
        }
      });
      DataLayer.pushEvent(dataLayerEvent);
    }
  }, [store, type, timeSlot, appointment, isVirtualAppointmentType]);
  if (!surveyUrl) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    AppointmentSurvey,
    {
      ...props,
      labels,
      surveyUrl,
      onClick: onSurveyLinkClick
    }
  );
};
export {
  AppointmentSurveyContainer as default
};
//# sourceMappingURL=AppointmentSurveyContainer.js.map
